import { reportServerApi, routingRuleApi } from "@/api";
import cfg from "@/service/Configurations";
import {
    getConnectionsData,
    getConnectionsErrorCode,
    getConnectionsMessageError,
    processTemplates,
    shouldProcessProvider
} from "@/modules/connections/helpers";

/**
 *  Obtener las conexiones
 */
export const getConnections = async ({ commit, rootState }) => {
    try {
        commit('setLoading', true);
        const { data } = await routingRuleApi.get('/api/egresses/routing_rules', rootState.auth.config);
        const connections = getConnectionsData(data);

        commit('setConnections', connections );
        commit('setLoading', false);

        return {
            ok: true
        }
    } catch (error) {
        commit( 'setLoading', false );
        const code = getConnectionsErrorCode(error);

        return {
            ok: false,
            code,
            message: 'No se pudieron obtener las conexiones.'
        }
    }
}

/**
 *  Obtener una conexión
 */
export const getConnection = async ({ commit, rootState }, id) => {
    try {
        commit('setLoading', true);

        const { data } = await routingRuleApi.get(`/api/egresses/routing_rules/${id}`, rootState.auth.config);

        commit('setLoading', false);

        commit('setConnection', data );

        return {
            ok: true
        }
    } catch (error) {
        commit('setLoading', false);

        return {
            ok: false,
            message: `No se pudo obtener la conexión ${id}`
        }
    }
}

/**
 *  Crear una conexión
 */
export const createConnection = async ({ commit, rootState }, dataForm) => {
    try {
        commit('setLoading', true);

        const { data } = await routingRuleApi.post(
            '/api/egresses/routing_rules',
            dataForm,
            rootState.auth.config
        );

        commit('setLoading', false);

        return {
            ok: true,
            message: " Se creo la conexión correctamente ",
            data
        }
    } catch (error) {
        const message = getConnectionsMessageError(
            error,
            'No se pudo crear la conexión, reintente luego...'
        );
        commit('setLoading', false);
        return {
            ok: false,
            message
        }
    }
}

/**
 *  Actualizar una conexión
 */
export const updateConnection = async ({ commit, rootState }, dataUpdate) => {
    try {
        commit('setLoading', true);
        const { id, dataForm } = dataUpdate;
        const { data } = await routingRuleApi.put(
            `/api/egresses/routing_rules/${id}`,
            dataForm,
            rootState.auth.config
        );

        commit('setLoading', false);

        return {
            ok: true,
            message: " Se actualizó la conexión correctamente ",
            data
        }
    } catch (error) {
        const message = getConnectionsMessageError(
            error,
            'No se pudo actualizar la conexión, reintente luego...'
        );
        commit('setLoading', false);
        return {
            ok: false,
            message
        }
    }
}

/**
 * Actualizar configuración de fetching
 */
export const updateFileFetchingConfiguration = async ({ commit, rootState }, dataUpdate) => {
    try {
        commit('setLoading', true);
        const { id, dataForm } = dataUpdate;
        const { data } = await routingRuleApi.put(`/api/egresses/routing_rules/${id}/fetch_rule`, dataForm,
            rootState.auth.config);

        commit('setLoading', false);

        return {
            ok: true,
            message: " Se actualizó la conexión correctamente ",
            data
        }
    } catch (error) {
        let message = 'No se pudo actualizar la configuración de procesamiento de archivos de la conexión, ' +
            'reintente luego...';
        if (error.response?.data.message) {
            message = error.response.data.message;
        }
        commit('setLoading', false);
        return {
            ok: false,
            message
        }
    }
}


/**
 *  Eliminar una configuración de fetching de una conexión
 */
export const deleteFileFetchingConfiguration = async ({ commit, rootState }, connectionId) => {
    try {
        commit('setLoading', true);
        commit('setConnections', [] );
        const { data } = await routingRuleApi.delete(
            `/api/egresses/routing_rules/${connectionId}/fetch_rule`,
            rootState.auth.config
        );

        commit('setLoading', false);
        return {
            ok: true,
            message: " Se eliminó la conexión correctamente ",
            data
        }
    } catch (error) {
        const message = getConnectionsMessageError(
            error,
            'No se pudo eliminar la conexión, reintente luego...'
        );
        commit('setLoading', false);
        return {
            ok: false,
            message
        }
    }
}


/**
 *  Eliminar una conexión
 */
export const deleteConnection = async ({ commit, rootState }, id) => {
    try {
        commit('setLoading', true);
        commit('setConnections', [] );
        const { data } = await routingRuleApi.delete(`/api/egresses/routing_rules/${id}`, rootState.auth.config);

        commit('setLoading', false);
        return {
            ok: true,
            message: " Se eliminó la conexión correctamente ",
            data
        }
    } catch (error) {
        const message = getConnectionsMessageError(
            error,
            'No se pudo eliminar la conexión, reintente luego...'
        );
        commit('setLoading', false);
        return {
            ok: false,
            message
        }
    }
}


/**
 *  Obtener los templates disponibles
 */
export const getTemplates = async ({ commit }) => {
    try {
        const allTemplates = [];

        const { data } = await reportServerApi.get('/api/report_templates');

        const basePath = cfg.getConfiguration('VUE_APP_REPORT_SERVER_BASE_PATH');

        if (!data[ basePath ]) {
            throw new Error(`No se pudieron obtener los templates para ${ basePath }.`);
        }

        for (const provider in data[ basePath ]) {
            const templates = data[ basePath ][ provider ];

            if (shouldProcessProvider(templates, provider)) {
                const templates_aux = processTemplates(templates, basePath, provider);
                const datatemplate = {
                    provider,
                    templates: templates_aux,
                };
                allTemplates.push(datatemplate);
            }
        }
        commit('setTemplatesBack', allTemplates );

        return {
            okTemplates: true,
        };
    } catch (error) {
        return {
            okTemplates: false,
            messageTemplates: 'No se pudieron obtener los templates.',
        };
    }
}
